<div class="offcanvas offcanvas-bottom show custom-bottom-radius" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
  <div class="offcanvas-header align-items-center">
    <h5 id="offcanvasBottomLabel" class="mb-0">{{ product.name }}</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" (click)="closeProductVariantsModal()"></button>
  </div>
  <div class="offcanvas-body">
    <div class="d-flex flex-column gap-2">
      @for(variant of product.variants; track $index) {
      <div class="d-flex justify-content-between align-items-center" [ngClass]="variant.status === 'OUT_OF_STOCK' ? 'opacity-50 pointer-events-none' : ''">
        <div class="d-flex align-items-center gap-2">
          <div class="position-relative">
            <img
              [src]="variant.assets.length > 0 && variant.assets[0].url ? helper.imageUrl + variant.assets[0].url : 'assets/images/default-image.jpg'"
              alt="Child Image"
              class="w-100 h-auto"
            />
            @if(variant && variant.status === "OUT_OF_STOCK") {
            <div class="d-flex justify-content-center w-100 position-absolute top-0">
              <span class="px-2 bg-danger text-white tag-text text-ellipsis">{{ "label-title.out-of-stock" | translate }}</span>
            </div>
            } @else { @if (calculateDiscountPercentage(variant.discountedPrice, variant.price)) {
            <div class="product-offer justify-content-center w-100 position-absolute top-0">
              <span class="offer-badge">{{
                "label-title.off-qd"
                  | translate : { _VALUE: calculateDiscountPercentage(variant.discountedPrice, variant.price).toFixed(helper.adminSettings.decimalPointValue) | number : "1.0-0" }
              }}</span>
            </div>
            } }
          </div>
          <div>
            @if(product.variantType === helper.VariantType.UNIT){
            <div class="product-tags">
              <span class="product-tag">{{ variant.unit.unitValue }} {{ helper.UnitTypeString[variant.unit.unitType] | translate }}</span>
            </div>
            } @else if (product.variantType === helper.VariantType.SIZE && variant.unit.unitDescription) {
            <div class="product-tags">
              <span class="product-tag">{{
                variant.unit && variant.unit.unitQty === 1 ? variant.unit.unitDescription : variant.unit.unitQty + " x " + variant.unit.unitDescription
              }}</span>
            </div>
            }
            <div class="product-price">
              <div class="d-flex ms-1 align-items-center">
                <span class="current-price">
                  {{
                    variant.discountedPrice === 0 ? (0).toFixed(helper.adminSettings?.decimalPointValue) : variant.discountedPrice.toFixed(helper.adminSettings?.decimalPointValue)
                  }}
                </span>
                <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                  {{ helper.currencySign }}
                </span>
              </div>
              <div class="d-flex ms-1 align-items-center original-price">
                <span>
                  {{ variant.discountedPrice !== variant.price ? variant.price.toFixed(helper.adminSettings?.decimalPointValue) : "" }}
                </span>
                <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                  {{ variant.discountedPrice !== variant.price ? helper.currencySign : "" }}
                </span>
              </div>
            </div>
          </div>
        </div>
        @if(!getVariantQuantity(variant._id)){
        <button
          class="add-button"
          (click)="addProductToCart(variant)"
          [ngStyle]="gridChildViewConfig && gridChildViewConfig.button ? getButtonStyle(gridChildViewConfig.button) : null"
        >
          <span
            class="icon"
            [ngStyle]="gridChildViewConfig && gridChildViewConfig.button ? { color: gridChildViewConfig.button.bgColor, backgroundColor: gridChildViewConfig.button.color } : null"
            ><i class="ri-add-line"></i
          ></span>
          {{ "button-title.add" | translate }}
        </button>
        } @else if(helper.route.url.includes("/users/create-booking/services") && variant.maxQtyAddInCart === 1) {
        <button
          class="add-button"
          (click)="decrementProductQuantity(variant)"
          [ngStyle]="gridChildViewConfig && gridChildViewConfig.button ? getButtonStyle(gridChildViewConfig.button) : null"
        >
          {{ "button-title.remove-product" | translate }}
        </button>
        } @else {
        <div class="add-button gap-2" [ngStyle]="gridChildViewConfig && gridChildViewConfig.button ? getButtonStyle(gridChildViewConfig.button) : null">
          <button
            class="button"
            (click)="decrementProductQuantity(variant)"
            [ngStyle]="{
              color: gridChildViewConfig && gridChildViewConfig.button ? gridChildViewConfig.button.color : ''
            }"
          >
            <i class="ri-subtract-line"></i>
          </button>
          <span class="white" [@quantityChangeAnimation]="getVariantQuantity(variant._id)">{{ getVariantQuantity(variant._id) }}</span>
          <button
            class="button"
            (click)="incrementProductQuantity(variant)"
            [disabled]="getVariantQuantity(variant._id) >= variant.maxQtyAddInCart"
            [ngStyle]="{
              color: gridChildViewConfig && gridChildViewConfig.button ? gridChildViewConfig.button.color : ''
            }"
          >
            <i class="ri-add-line"></i>
          </button>
        </div>
        }
      </div>
      }
    </div>
  </div>
  <div class="offcanvas-footer">
    <div class="w-100 d-flex justify-content-center p-2 rounded mt-3 cursor-pointer confirm-button" (click)="closeProductVariantsModal()">
      <span class="fs-6 white">{{ "button-title.confirm" | translate }}</span>
    </div>
  </div>
</div>
<div class="offcanvas-backdrop fade show"></div>
